import { camelToSnakeKeys } from '@convenia/helpers'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { PERSONAL_AREA } from '../consts'
import { mapFiles } from './upload'

export const mapEducation = (data = {}, params) => ({
  ...data,
  educationTypeId: data?.educationType?.id,
  files: mapFiles(data?.documentFiles || [], params)
})

export const mapEducationInput = ({ entityId, schema, data, invalidFields = [] } = {}) => ({
  ...camelToSnakeKeys({
    ...(!invalidFields.includes('educationType') ? { educationTypeId: data?.educationTypeId } : {}),
    ...(!invalidFields.includes('institution') ? { institution: data?.institution } : {}),
    ...(!invalidFields.includes('course') ? { course: data?.course } : {}),
    ...(!invalidFields.includes('graduationYear') ? { graduationYear: data?.graduationYear ? +data.graduationYear : null } : {}),
  }),
  custom_fields: mapCustomFieldValues({
    data,
    schema,
    entityId,
    sectionId: PERSONAL_AREA.EDUCATIONS
  })
})
